import React, { useEffect, useState } from 'react';

import { nanoid } from '@reduxjs/toolkit';

import { bemCssModules, getTestId } from '@utils';

import style from './Switch.scss';

const cn = bemCssModules(style, 'Switch');
const ti = getTestId('Switch');

export type TSwitch = {
  children?: React.ReactNode;
  className?: string;
  value?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
};

export const Switch: React.FC<TSwitch> = props => {
  const { children, className, onChange, disabled, value } = props;

  const [id] = useState(nanoid());
  const [checked, setChecked] = useState(value);

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = event => {
    event.stopPropagation();
    if (!disabled) {
      setChecked(prev => !prev);
      onChange?.(!checked);
    }
  };

  useEffect(() => {
    setChecked(value);
  }, [value]);

  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      <button
        className={cn('button', { checked, disabled })}
        id={id}
        type="button"
        aria-label="Switch"
        onClick={handleClick}
        disabled={disabled}
        data-testid={ti(`checkbox_${checked ? 'on' : 'off'}`)}
      />
      {children && (
        <label className={cn('label')} htmlFor={id}>
          {children}
        </label>
      )}
    </div>
  );
};

export default Switch;
